import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Compass, Gamepad2, Hammer, Users, CircleUser } from 'lucide-react';
import './MobileTabBar.css';

// 手机端底部主导航。桌面端用顶栏，手机端用拇指能到的地方。
// 只放五个最高频的去处；其余（钱包、设置、帮助）仍在头像菜单里。
const TABS = [
  { to: '/', label: '探索', icon: Compass, exact: true },
  { to: '/store', label: '星游', icon: Gamepad2 },
  { to: '/maps', label: '创作', icon: Hammer },
  { to: '/community', label: '社区', icon: Users },
  { to: '/library', label: '我的', icon: CircleUser },
];

export default function MobileTabBar() {
  const location = useLocation();

  return (
    <nav className="mobile-tabbar" aria-label="主导航">
      {TABS.map(tab => {
        const Icon = tab.icon;
        const active = tab.exact
          ? location.pathname === tab.to
          : location.pathname === tab.to || location.pathname.startsWith(tab.to + '/');
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={'mobile-tab' + (active ? ' active' : '')}
            aria-current={active ? 'page' : undefined}
          >
            <span className="mobile-tab-icon"><Icon size={21} strokeWidth={active ? 2.3 : 1.9} /></span>
            <span className="mobile-tab-label">{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
